{
  "CodeDeliveryFailureException": "No se pudo enviar el código. Inténtalo nuevamente más tarde.",
  "CodeMismatchException": "El código ingresado no es válido; verifique e intente nuevamente.",
  "ExpiredCodeException": "Este código ha expirado.",
  "InvalidParemeterException": "Algo salió mal. Inténtalo de nuevo más tarde.",
  "LimitExceededException": "Demasiados intentos. Inténtalo de nuevo más tarde.",
  "NotAuthorizedException": "Su correo electrónico y/o contraseña son incorrectos.",
  "UserNotConfirmedException": "La cuenta no está confirmada.",
  "UserNotFoundException": "Su correo electrónico y/o contraseña son incorrectos.",
  "UsernameExistsException": "La cuenta ya existe.",
  "accountNotConfirmed": "Cuenta no confirmada",
  "anUnknownErrorOccurred": "Se produjo un error desconocido",
  "codeSentToast": "Código enviado.",
  "codeStringFieldLabel": "Código",
  "codeStringFieldPlaceholder": "Introducir código",
  "confirmAccount": "Confirmar cuenta",
  "confirmAccountButton": "Confirmar cuenta",
  "confirmPasswordFieldLabel": "confirmar Contraseña",
  "confirmPasswordFieldPlaceholder": "*******",
  "contactUs": "Contáctenos",
  "createAnAccount": "Crear una cuenta",
  "createUserAccount": "Crear cuenta de usuario",
  "credentialsSuccess": "Ahora puedes iniciar sesión con tus nuevas credenciales.",
  "currentPasswordFieldLabel": "Contraseña",
  "currentPasswordFieldPlaceholder": "*******",
  "emailFieldLabel": "Correo electrónico",
  "emailFieldPlaceholder": "*******@ejemplo.com",
  "enterCodeFromYourEmail": "Introduzca el código de confirmación que le enviamos a su dirección de correo electrónico.",
  "enterYourEmail": "Introduzca su dirección de correo electrónico",
  "needToConfirmYourAccount": "¿Necesitas confirmar tu cuenta?",
  "newPasswordFieldLabel": "Contraseña",
  "newPasswordFieldPlaceholder": "Introducir contraseña",
  "passwordResetCodeSentWithEmail": "Enviamos un código de restablecimiento de contraseña de un solo uso a {{email}} (Asegúrese de verificar su filtro de correo no deseado)",
  "passwordResetLinkTo": "¿Olvidaste tu contraseña?",
  "passwordResetTitle": "Restablecer contraseña",
  "signIn": "Iniciar sesión",
  "signOut": "Desconectar",
  "youMustConfirmYourAccount": "Debes confirmar tu cuenta antes de poder iniciar sesión."
}
